import { render, staticRenderFns } from "./ProtocolList.vue?vue&type=template&id=41aa61d2&scoped=true&"
import script from "./ProtocolList.vue?vue&type=script&lang=js&"
export * from "./ProtocolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aa61d2",
  null
  
)

export default component.exports